import _concat from "lodash/concat";
import profile from "./profile";
import stampingProfile from "./stampingProfile";
import branding from "./branding";

export default {
  path: "/profile",
  component: () => import("@/layouts/FullLayout"),
  children: _concat(profile, stampingProfile, branding)
};
